var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "ambience-card",
      class: { "ambience-card--clickable": _vm.clickable },
      attrs: { outlined: "" },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "v-card-text",
        { staticClass: "pb-2" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-space-between align-start mb-2" },
            [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "text-subtitle-1 font-weight-medium" },
                  [_vm._v(" " + _vm._s(_vm.ambience.name) + " ")]
                ),
                _c("div", { staticClass: "text-caption grey--text" }, [
                  _vm._v(" " + _vm._s(_vm.locationText) + " "),
                ]),
              ]),
              _vm.showEditButton
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("edit", _vm.ambience)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("mdi-pencil-outline"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-divider", { staticClass: "my-2" }),
          _c(
            "div",
            { staticClass: "d-flex align-center mb-2" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-1", attrs: { small: "", color: "grey" } },
                [_vm._v("mdi-account-group")]
              ),
              _c("span", { staticClass: "text-body-2" }, [
                _vm._v(" " + _vm._s(_vm.activeCapacity) + " lugares "),
              ]),
              _c(
                "v-chip",
                {
                  staticClass: "ml-2",
                  attrs: {
                    "x-small": "",
                    color: _vm.capacityModeColor,
                    outlined: "",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.capacityModeLabel) + " ")]
              ),
            ],
            1
          ),
          _vm.ambience.type
            ? _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "v-chip",
                    {
                      attrs: { "x-small": "", color: "primary", outlined: "" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.ambience.type.name || _vm.ambience.type) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasResources
            ? _c("sys-ambience-resource-tags", {
                staticClass: "mt-2",
                attrs: {
                  resources: _vm.ambience.resources,
                  "max-display": 4,
                  "x-small": "",
                },
              })
            : _vm._e(),
          _vm.showOccupation
            ? _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-space-between align-center mb-1",
                    },
                    [
                      _c("span", { staticClass: "text-caption grey--text" }, [
                        _vm._v("Ocupação"),
                      ]),
                      _c(
                        "span",
                        { staticClass: "text-caption font-weight-medium" },
                        [_vm._v(_vm._s(_vm.occupationPercent) + "%")]
                      ),
                    ]
                  ),
                  _c("v-progress-linear", {
                    attrs: {
                      value: _vm.occupationPercent,
                      color: _vm.occupationColor,
                      height: "6",
                      rounded: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.showActions
        ? _c(
            "v-card-actions",
            { staticClass: "pt-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "", small: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$emit("view", _vm.ambience)
                    },
                  },
                },
                [_vm._v(" Ver detalhes ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }